import {all, fork, put, takeEvery,takeLatest, call, delay} from "redux-saga/effects"

import {
  SALES_PERSON_PREVIEW,
  SALES_PERSON_NEW,
  SALES_PERSON_UPDATE,
  SALES_PERSON_REMOVE,
  SALES_PERSON_SEARCH
} from "constants/ActionTypes"

import {salesPersonDataSourceUpdate,salesPersonProcessSuccess,salesProcessReset} from "appRedux/actions/setup/channel/SalesPerson"
import {userSignOut} from "appRedux/actions/Auth"

import { APIGetRequest,APIPostRequest } from "util/connection"
import { API_URL_V1,API_PMS_HEADERS } from "constants/ApiSetting"
import { isUndefined,filter,orderBy } from "lodash"
import { IndexedDBAdd,IndexDBGetDataAll } from "util/indexedDBLibrary"
import { getItems } from "util/localStorage"

function* salesPersonPreviewProcess({payload}){
    const  { access_token }  = yield call(getItems, ['access_token'])
    const AccessToken = access_token
    const url = `${API_URL_V1}pms/masterfile/salesStaff/`
    API_PMS_HEADERS.headers.Authorization = `Bearer ${AccessToken}`
  
    try {
      const response = yield APIGetRequest(url,API_PMS_HEADERS)

      if(response.status === 200)
      {
            const salesPersonDataSource = orderBy(response.data,[o => o.name.toLowerCase()],['asc']).map((obj,key) =>{
              const container = {}
                    container.key = key
                    container.sales_person_id = obj.id
                    container.sales_person_name = obj.name
                    container.enabled = obj.enabled
                return container
            })
            /* if no error put everything to reducer */
            yield put(salesPersonDataSourceUpdate(salesPersonDataSource))
            yield delay(100)
            yield IndexedDBAdd("ListBoxDB","objStoreSalesList",salesPersonDataSource)

      }else{
            /* Show error message and signout */
            const {message,data} = response.data
            const processStatus = { status: false, action: "preview", message }
            yield put(salesPersonProcessSuccess(processStatus))
            yield delay(100)
            yield put(salesProcessReset())
            yield delay(100)
            if(response.status === 403){
              /* if data is not null force signout */
              if(data)
                yield put(userSignOut())
            }
      }
      
    } catch (error) {
        const processStatus = { status: false, action: "preview", message:error }
        yield put(salesPersonProcessSuccess(processStatus))
        yield delay(100)
        yield put(salesProcessReset())
        yield delay(100)
    }
    
}

function* salesPersonSearchProcess({payload}){
  const storeValue = yield IndexDBGetDataAll('ListBoxDB', 'objStoreSalesList')
  const ReformalData = [...storeValue[0]]
  const keyword = payload.toLowerCase()

  if(!isUndefined(keyword)){
      /* Search by name */
      const filtered_sales_name = filter(ReformalData, function(o) {
        return o.sales_person_name.toLowerCase().indexOf(keyword) > -1
      })

      const mergeData = [...new Set([...filtered_sales_name])]

      yield put(salesPersonDataSourceUpdate(mergeData))
  }else 
      yield put(salesPersonDataSourceUpdate(ReformalData))
}

function* salesPersonCreateProcess({payload}){
  const {sales_person_name , active:salesActive} = payload
  let salesPersonInfo = {name:sales_person_name, enabled:salesActive}
      
      
      try {
            const  { access_token }  = yield call(getItems, ['access_token'])
            const AccessToken = access_token
            const url = `${API_URL_V1}pms/masterfile/salesStaff/create/`
            API_PMS_HEADERS.headers.Authorization = `Bearer ${AccessToken}`
            const API_DATABODY  = salesPersonInfo
            const response = yield APIPostRequest(url,API_DATABODY,API_PMS_HEADERS)

            if(response.status === 200){
                const processStatus = { status: true, action: "create", message:"Create success." }
                yield put(salesPersonProcessSuccess(processStatus))
                yield delay(100)
                yield put(salesProcessReset())
                yield delay(100)
            }else{  
                const {message,data} = response.data
                const processStatus = { status: false, action: "create", message }
                yield put(salesPersonProcessSuccess(processStatus))
                yield delay(100)
                yield put(salesProcessReset())
                yield delay(100)
                if(response.status === 403){
                  /* if data is not null force signout */
                  if(data)
                    yield put(userSignOut())
                }
            }

      } catch (error) {
            const processStatus = { status: false, action: "create", message:error }
            yield put(salesPersonProcessSuccess(processStatus))
            yield delay(100)
            yield put(salesProcessReset())
            yield delay(100)
      }
}

function* salesPersonUpdateProcess({payload}){
  const {sales_person_name,sales_person_id,active:salesActive} = payload
  let salesInfo = {}
      salesInfo.id = sales_person_id
      salesInfo.name = sales_person_name
      salesInfo.enabled = salesActive
  
  try {
        const  { access_token }  = yield call(getItems, ['access_token'])
        const AccessToken = access_token
        const url = `${API_URL_V1}pms/masterfile/salesStaff/update/`
        API_PMS_HEADERS.headers.Authorization = `Bearer ${AccessToken}`
        const API_DATABODY  = salesInfo
        const response = yield APIPostRequest(url,API_DATABODY,API_PMS_HEADERS)

        if(response.status === 200){
            const processStatus = { status: true, action: "update", message:"Update success." }
            yield put(salesPersonProcessSuccess(processStatus))
            yield delay(100)
            yield put(salesProcessReset())
            yield delay(100)
        }else{      
            const {message,data} = response.data
            const processStatus = { status: false, action: "update", message }
            yield put(salesPersonProcessSuccess(processStatus))
            yield delay(100)
            yield put(salesProcessReset())
            yield delay(100)
            if(response.status === 403){
              /* if data is not null force signout */
              if(data)
                yield put(userSignOut())
            }
        } 
  } catch (error) {
        const processStatus = { status: false, action: "update", message:error }
        yield put(salesPersonProcessSuccess(processStatus))
        yield delay(100)
        yield put(salesProcessReset())
        yield delay(100)
  }
}

function* salesPersonRemoveProcess({payload}){
    const salesPersonID = payload
    
    try{
        const  { access_token }  = yield call(getItems, ['access_token'])
        const AccessToken = access_token
        const url = `${API_URL_V1}pms/masterfile/salesStaff/delete/`
        API_PMS_HEADERS.headers.Authorization = `Bearer ${AccessToken}`
        const API_DATABODY = {id : salesPersonID}
        const response = yield APIPostRequest(url,API_DATABODY,API_PMS_HEADERS)
        if(response.status === 200){
          const processStatus = { status: true, action: "delete", message:"Delete success." }
          yield put(salesPersonProcessSuccess(processStatus))
          yield delay(100)
          yield put(salesProcessReset())
          yield delay(100)
        }else{   
          const {message,data} = response.data
          const processStatus = { status: false, action: "delete", message }
          yield put(salesPersonProcessSuccess(processStatus))
          yield delay(100)
          yield put(salesProcessReset())
          yield delay(100)
          if(response.status === 403){
            /* if data is not null force signout */
            if(data)
              yield put(userSignOut())
          }
        } 
    }
    catch(error){
      const processStatus = { status: false, action: "delete", message:error }
      yield put(salesPersonProcessSuccess(processStatus))
      yield delay(100)
      yield put(salesProcessReset())
      yield delay(100)
    }
}

/* Watcher Saga */
export function* salesPersonPreview() {
  yield takeLatest(SALES_PERSON_PREVIEW, salesPersonPreviewProcess)
}
export function* salesPersonSearch(){
  yield takeLatest(SALES_PERSON_SEARCH, salesPersonSearchProcess)
}
export function* salesPersonCreate(){
  yield takeEvery(SALES_PERSON_NEW,salesPersonCreateProcess)
}
export function* salesPersonUpdate(){
  yield takeEvery(SALES_PERSON_UPDATE, salesPersonUpdateProcess)
}
export function* salesPersonRemove(){
  yield takeEvery(SALES_PERSON_REMOVE,salesPersonRemoveProcess)
}

export default function* rootSaga() {
  yield all([fork(salesPersonPreview),
             fork(salesPersonSearch),
             fork(salesPersonCreate),
             fork(salesPersonUpdate),
             fork(salesPersonRemove)])


}
